<template>
  <b-button @click="$emit('click', $event)" size="sm" variant="danger" v-b-tooltip.hover :title="showToolTip ? 'Удалить' : ''"><i class="fa fa-remove"></i></b-button>
</template>

<script>

export default ({
  name: "button-delete",
  computed: {
    showToolTip() {
      return this.$store.state.userSettings.showTooltips;
    }
  }
})
</script>
